var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('add-image-modal'),_c('add-link-modal'),_vm._l((_vm.items),function(item,index){return _c('menu-item',_vm._b({key:index},'menu-item',item,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }